// src/services/challengeAPI.js
import { API_BASE_URL } from '../../config/api';

// Helper function to get auth headers
const getAuthHeaders = () => {
  const token = localStorage.getItem('access_token');
  console.log('🔑 Token from localStorage:', token ? 'Present' : 'Missing');
  
  if (!token) {
    console.error('❌ No JWT token found in localStorage');
  }
  
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(errorData.error || errorData.message || 'Request failed');
  }
  const data = await response.json();
  console.log('✅ API Response:', data);
  return data;
};

// GET - Get all challenges
export const getChallengesAPI = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.is_daily !== undefined) queryParams.append('is_daily', params.is_daily);
    if (params.category) queryParams.append('category', params.category);
    
    const queryString = queryParams.toString();
    const url = `${API_BASE_URL}/api/challenges${queryString ? `?${queryString}` : ''}`;
    
    const res = await fetch(url, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Get challenges error:', error);
    throw error;
  }
};

// GET - Get challenge by ID
export const getChallengeByIdAPI = async (challengeId) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/challenges/${challengeId}`, {
      method: 'GET',
      headers: getAuthHeaders(),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Get challenge by ID error:', error);
    throw error;
  }
};

// PUT - Update challenge progress
export const updateChallengeProgressAPI = async (challengeId, progressData) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/challenges/${challengeId}/progress`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(progressData),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Update challenge progress error:', error);
    throw error;
  }
};

// POST - Create new challenge (Admin)
export const createChallengeAPI = async (challengeData) => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/challenges`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(challengeData),
      credentials: 'include'
    });
    return handleResponse(res);
  } catch (error) {
    console.error('❌ Create challenge error:', error);
    throw error;
  }
};

// Helper function to handle API errors
export const handleAPIError = (error) => {
  console.error('API Error:', error);
  return {
    message: error.message || 'An unexpected error occurred',
    status: 0,
  };
};
